import debounce from 'lodash/debounce';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'palette/Button';
import { BodyText } from 'palette/Typography';
import { ActiveFiltersList } from '@common/Filters/components/ActiveFiltersList';
import { MwcDescription } from '@common/Filters/components/MwcDescription';
import { MWC_FILTER_TYPES } from '@common/Filters/constants/filterTypes';
import { useTranslation } from '@common/Hooks/useTranslation';
import { GA_FILTERS_CATEGORY, GA_FILTER_CLEAR_ACTION, GA_FILTER_CLEAR_ALL_LABEL } from '@common/Tracking';
import { BEMBlock } from '@helpers/classnames';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';
import { toggleFilter, deselectAllFilters } from '../actions/filtersActions';

const SKIP_ACTIVE_FILTERS = ['gender', 'age', 'personalcategory'];
export const LIMIT = 20;

export function ActiveFilters({ isGroupByType }) {
    const dispatch = useDispatch();
    const translate = useTranslation();
    const stateActiveFilters = useSelector(({ filters }) => filters.activeFilters);

    const [block, BEMElement] = BEMBlock('filters-info');

    const activeFilters = [...stateActiveFilters]
        .filter(filterItem => !SKIP_ACTIVE_FILTERS.includes(filterItem.filterType))
        .reverse();
    const isMadeWithCareActive = activeFilters.some(filterItem => MWC_FILTER_TYPES.includes(filterItem.filterType));

    const filterClick = debounce((filter) => {
        dispatch(toggleFilter(filter));
    }, 250, {
        leading: true,
        trailing: false
    });

    const handleDeselectAllFiltersClick = () => {
        pushGAEventToDataLayer(GA_FILTERS_CATEGORY, GA_FILTER_CLEAR_ACTION, GA_FILTER_CLEAR_ALL_LABEL);
        dispatch(deselectAllFilters());
    };

    if (activeFilters.length === 0) {
        return null;
    }

    return (
        <div className={block}>
            <div className={BEMElement('list')}>
                <BodyText
                    level="2"
                    weight="bold"
                >
                    {`${translate('listing.filters.applied_filters')}:`}
                </BodyText>
                <div className={BEMElement('list-inner')}>
                    {
                        !isGroupByType && activeFilters.length > 0
                        && (
                            <Button
                                className="mr-16 mb-8"
                                iconName="palette_delete"
                                label={translate('listing.filter.clear_all.label')}
                                size="small"
                                theme="secondary"
                                onClick={handleDeselectAllFiltersClick}
                            />
                        )
                    }
                    <ActiveFiltersList
                        filters={activeFilters}
                        isGroupByType={isGroupByType}
                        onClick={filterClick}
                    />
                </div>
            </div>
            {isMadeWithCareActive && <MwcDescription />}
        </div>
    );
}
